import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Settings.css";

function SettingsPage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content">
                <h1 className="main-title">Settings Page</h1>
                <p className="main-description">Welcome to the Settings page!</p>
            </main>
        </div>
    );
}

export default SettingsPage;